import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Business } from '../models/business.model';
import { TimeZoneCode } from '../models/time-objects.model';
import { Country } from '../models/country.model';
import { Currency } from '../models/currency.model';
import { Locale } from '../models/locale.model';
import { BusinessTokenModel } from '../models/business-token.model';
import { BackofficesettingsModel } from '../models/backofficesettings.model';
import { HibernateData } from '../models/hibernate-data.model';
import { LoginResponseModel } from '../models/LoginResponse.model';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BusinessService {
  private business: Business;
  private loginResponse: LoginResponseModel;
  private configList: any;
  constructor(private httpClient: HttpClient) {

  }


 async loadBusiness() {
    return await firstValueFrom(this.getBusinessForUser()).then((business: Business) => {
     this.business = business;
     return true;
   });
 }
  setConfigList(configListStr: string) {
    if (configListStr !== null && configListStr !== undefined) {
      this.configList = JSON.parse(configListStr);
    }
  }
  getConfigList(){
    return this.configList;
  }
  setLoginResponse(loginResponse: LoginResponseModel) {
    this.loginResponse = loginResponse;
  }

  async getBusinessForUserAsync() {
    return this.httpClient.get<Business>(environment.apiUrl+'rest/business');
  }

  getBusinessForUser() {
    return this.httpClient.get<Business>(environment.apiUrl+'rest/business');
  }

  setBusiness(business: Business) {
    this.business = business;
  }

  getBusiness() {
    return this.business;
  }

  getLoginResponse() {
    return this.loginResponse;
  }

  getBillingHash() {
    return this.httpClient.get<BusinessTokenModel>(environment.apiUrl+'rest/business/billingToken');
  }

  awakeFromHibernate() {
    return this.httpClient.post<Business>(environment.apiUrl+'rest/business/addNewSubscription', null);
  }

  hibernateAccount(hibernateData: HibernateData) {
    return this.httpClient.post(environment.apiUrl+'rest/business/hibernate', hibernateData);
  }

  getBackOfficeSettingsBusinessByKey(key: string) {
    return this.httpClient.get<BackofficesettingsModel>(`${environment.apiUrl}rest/backofficeSettings/business/${key}`);
  }

  getAllTimezones() {
    return this.httpClient.get<TimeZoneCode[]>(environment.apiUrl+'rest/timezones');
  }

  getAllCountries() {
    return this.httpClient.get<Country[]>(environment.apiUrl+'rest/country');
  }

  getAllCurrencies() {
    return this.httpClient.get<Currency[]>(environment.apiUrl+'rest/currency');
  }

  getLocales() {
    return this.httpClient.get<Locale[]>(environment.apiUrl+'rest/localenew');
  }

  getClientLabels(){
    let clientLabels;
  if(this.loginResponse.planId === 28 || this.loginResponse.planId === 29){//RECRUITER PLAN TYPE -- IMPLEMENTING FOR TT-4347
   clientLabels = [
    {'single': 'candidate', 'plural': 'candidates'},
    {'single': 'prospect', 'plural': 'prospects'}
  ]
} else {
  clientLabels = [
    {'single': 'client', 'plural': 'clients'},
    {'single': 'candidate', 'plural': 'candidates'},
    {'single': 'student', 'plural': 'students'},
    {'single': 'customer', 'plural': 'customers'},
    {'single': 'patient', 'plural': 'patients'}
  ]
}

let clientLabelStringArray = ['client', 'candidate', 'student', 'customer', 'patient'];
if(clientLabelStringArray.indexOf(this.configList['clientLabel'])===-1){
  let accountClientLabel = {'single': this.configList['clientLabel'], 'plural': this.configList['clientLabelPlural']};
  clientLabels.push(accountClientLabel);
}
return clientLabels;
}
getStaffLabels(){
  let staffLabels = [
    {'single': 'staff', 'plural': 'staff'},
    {'single': 'recruiter', 'plural': 'recruiters'},
    {'single': 'tutor', 'plural': 'tutors'},
    {'single': 'teacher', 'plural': 'teachers'},
    {'single': 'advisor', 'plural': 'advisors'},
    {'single': 'practitioner', 'plural': 'practitioners'},
    {'single': 'doctor', 'plural': 'doctors'}
  ]
  var staffLabelStringArray = ['staff', 'recruiter', 'tutor', 'teacher', 'advisor', 'practitioner', 'doctor'];
  if(staffLabelStringArray.indexOf(this.configList['staffLabel']) ===-1){
    let accountStaffLabel = {'single': this.configList['staffLabel'], 'plural': this.configList['staffLabelPlural']};
    staffLabels.push(accountStaffLabel);
  }
  return staffLabels;
}

}
